import React  from "react";

const InputField = ({ value, label, name, placeholder, type, onChange }) => (

  <div className="form-group customlogin">
    <input className="form-control-input"
      type={type}
      value={value}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      required
    />
    {label && <label className="label-control" htmlFor="remail">{label}</label>}
    <div className="help-block with-errors"></div>
  </div>

        // <div className="form-group">
        // <input type="email" className="form-control-input" id="remail" name="remail"
        // value={email} onChange={handleChange} 
        // required />
        // <label className="label-control" htmlFor="remail">Email</label>
        // <div className="help-block with-errors"></div>
        // </div>
);

export default InputField;